import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Axios from "../../axios/axios";
import { ListProducts } from "../../actions/productAction";
import { useSelector, useDispatch } from "react-redux";
import RentOutDiv from "./RentOutDiv";
import { ListCategories } from "../../actions/categoryAction";
import RentOutPrint from "../Print/RentOutPrint";
import { PDFDownloadLink, Document, Page } from "@react-pdf/renderer";
import { ToastContainer, toast } from "react-toastify";
import QRCode from "qrcode";
import "./RentOut.css";
import Loader from "../Common/Loader";

export default function RentOut() {
  const dispatch = useDispatch();

  const productList = useSelector((state) => state.productList);
  const { products } = productList;

  // const catList = useSelector((state) => state.catList);
  // const { categories } = catList;
  const qrInputRef = useRef(null);
  const modalRef = useRef(null);

  const [qrResult, setQrResult] = useState(null);
  const [showQRModal, setShowQRModal] = useState(false);
  const [qrPending, setQrPending] = useState(false);
  const [qrCodeForPdf, setQrCodeForPdf] = useState("");
  const [scanStage, setScanStage] = useState("ORDER");
  const [scannedQRData, setScannedQRData] = useState(null);
  const [showStockModal, setShowStockModal] = useState(false);
  const [scanStockDetails, setScanStockDetails] = useState(null);
  const [scannedStockData, setScannedStockData] = useState(null);
  const [showStockScanModal, setShowStockScanModal] = useState(false);
  const [AddOrderModal, setAddOrderModal] = useState(false);
  const [tempSelectedOrder, setTempSelectedOrder] = useState("");
  const [AddNewItemModal, setAddNewItemModal] = useState(false);
  const [showAddItemModal, setShowAddItemModal] = useState(false);
  const [scannedNewItem, setScannedNewItem] = useState(null);
  const [addItemStartDate, setAddItemStartDate] = useState(getTodayDate());
  const [addItemEndDate, setAddItemEndDate] = useState(getTodayDate());
  const [addItemDays, setAddItemDays] = useState(1);
  const [addItemQnty, setAddItemQnty] = useState(1);
  const [checkingAvailability, setCheckingAvailability] = useState(false);
  const [isLoadingOrderScan, setIsLoadingOrderScan] = useState(false);

  const [customer, setCustomer] = useState("");

  const [categories, setCategories] = useState([]);
  const [orders, setOrders] = useState([]);

  const [customerDetails, setCustomerDetails] = useState();
  const [customerError, setCustomerError] = useState("");
  const [selectedOrder, setOrderSelected] = useState("");

  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchCustomerLoading, setCustomerLoading] = useState(false);
  const [searchCustomerRes, setResCustomer] = useState("");
  const [searchCustomerCode, setResCustomerCode] = useState("");
  const [product, setProduct] = useState([]);

  console.log(product, "product");
  const [stocksList, setStockList] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);

  const [isDelivered, setDelivered] = useState(false);
  const [isReturn, setIsReturn] = useState(false);
  const [compleat, setComplete] = useState(false);

  const [category, setCategory] = useState("");
  const [productList_, setProductList] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("cash");

  const gettodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // Months are 0-indexed
    const day = today.getDate();

    // Ensure two-digit month and day
    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedDay = day < 10 ? `0${day}` : day;

    return `${year}-${formattedMonth}-${formattedDay}`;
  };

  const [startDate, setStartDate] = useState(gettodayDate());

  const [endDate, setEndDate] = useState(gettodayDate());
  const [newProduct, setNewProduct] = useState("");
  const [availability, setAvailability] = useState("");

  const [productsForPrint, setProductsForPrint] = useState([]);

  const [recAmount, setRecAmount] = useState(0);
  const [days, setDays] = useState(1);
  const [qnty, setQnty] = useState(1);
  const today = new Date().toISOString().split("T")[0];
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    console.log("loader changed ->", loader);
  }, [loader]);

  useEffect(() => {
    console.log("compleat changed ->", compleat);
  }, [compleat]);

  useEffect(() => {
    console.log("productsForPrint ->", productsForPrint);
  }, [productsForPrint]);

  useEffect(() => {
    console.log("qrCodeForPdf length ->", qrCodeForPdf?.length);
  }, [qrCodeForPdf]);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  useEffect(() => {
    if (selectedOrder != "" && selectedOrder != undefined) {
      getOrder(selectedOrder);
    }
  }, [selectedOrder]);

  // const [products, setProducts] = useState([]);
  useEffect(() => {
    dispatch(ListProducts({ pagination: false }));
    fetchCategory();
  }, [dispatch]);

  const fetchCategory = async () => {
    try {
      const res = await Axios.get(`/api/category?pageNumber=1&pageSize=200`);
      console.log(res.status, res.data.categories, "category response");
      if (res.status >= 200 && res.status < 300) {
        setCategories(res.data.categories);
      }
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  };

  // Fetch products directly from the API
  // useEffect(() => {

  //   fetchProducts();
  // }, []);

  //   const fetchProducts = async () => {
  //     try {
  //       const res = await Axios.get('/api/products?pagination=false');
  //       setProducts(res.data.products);
  //     } catch (error) {
  //       console.error('Error fetching products:', error);
  //     }
  //   };
  //   console.log(products, "profffffffffffffffffducts")

  const getOrder = async (selectedOrder) => {
    try {
      const { data } = await Axios.get(`/api/order/${selectedOrder}`);
      setOrderDetails(data);

      const orderItems = data?.orderItems || [];
      let arrayData = [];

      for (let index = 0; index < orderItems.length; index++) {
        const orderItem = orderItems[index];
        const productId = orderItem?.product || null;

        let stocks = [];

        if (productId) {
          try {
            const response = await Axios.get(
              `/api/order/get-stock/${productId}`,
            );
            stocks = response?.data?.data || [];
          } catch (err) {
            console.warn(`Stock not found for deleted product: ${productId}`);
            stocks = [];
          }
        }

        const obj = {
          product: productId, // keep ID even if deleted
          startDate: orderItem?.startDate || "N/A",
          endDate: orderItem?.endDate || "N/A",
          isDelivered: orderItem?.isDelivered ?? false,
          isReturn: orderItem?.isReturn ?? false,
          amount: orderItem?.amount ?? 0,
          days: orderItem?.days ?? 0,
          qnty: orderItem?.qnty ?? 1,
          index_: index,
          prodPrice: orderItem?.prodPrice ?? 0,
          _id: orderItem?._id ?? null,
          stocks,
          stock: orderItem?.stock || "",
          deliveredAt: orderItem?.deliveredAt || null,
          created: orderItem?.created || null,
          isProductDeleted: stocks.length === 0 && !orderItem?.stock, // optional UI flag
        };

        arrayData.push(obj);
      }

      setProduct(arrayData);
    } catch (error) {
      console.error("Error loading order:", error);
      setProduct([]);
    }
  };

  const checkStockIsRentOut = async (prod) => {
    const { data } = await Axios.get(`/api/order/get-stock/${prod}`);

    return data;
  };

  const customerSearchFunction = async (e) => {
    if (e.keyCode === 13) {
      setSearchCustomer(e.target.value);

      if (e.target.value === "") {
        setResCustomer("Please enter mobile number");
      } else {
        setCustomerLoading(true);

        const { data } = await Axios.get(`/api/user/mob/${e.target.value}`);
        setResCustomerCode(data.code);
        if (data.code === 400) {
          setCustomerLoading(false);
          setResCustomer(data.message);
        } else {
          setCustomerLoading(false);
          setResCustomer(data.user.name);
          setCustomer(data.user._id);
          setCustomerDetails(data);

          let obj = {
            phone: parseInt(e.target.value),
          };
          const { data: data_ } = await Axios.post(
            `/api/order/rentout-orders`,
            obj,
          );

          let orderList = [];

          data_?.data?.forEach((order) => {
            const isSameCustomer = order?.user?._id === data.user._id; // ✅ IMPORTANT

            const hasPendingItems = order?.orderItems?.some(
              (item) => item.isDelivered === false || !item.stock,
            );
            const isCancelled = order?.status === "cancelled";

            if (isSameCustomer && hasPendingItems && !isCancelled) {
              orderList.push(order);
            }
          });

          if (orderList?.length === 0) {
            setCustomerError("No order found !");
          } else {
            setCustomerError(`${orderList?.length} order found on this `);

            // let arrayNew = [];
            // orderList?.map((data) => {
            //   let isItemDelivered = data?.orderItems?.some(
            //     (lt) => lt.isDelivered === true
            //   );

            //   if (isItemDelivered === false) {
            //     arrayNew.push(data);
            //   }
            // });

            setOrders(orderList);
          }
        }
      }
    }
  };

  // const productName = (proId) => {
  //   let data = products?.filter((data) => data._id === proId);

  //   return data.length > 0 ? data?.[0].name : '';
  // };
  // Get product name by ID
  const productName = (proId) => {
    if (!products || !Array.isArray(products)) return "Deleted Product";
    const product = products.find((p) => p._id === proId);
    return product ? product.name : "⚠️ Deleted Product";
  };

  const productPrice = (proId) => {
    let data = products.filter((data) => data._id === proId);

    return data[0].price;
  };

  // const changeCategory = (val) => {
  //   setCategory(val);

  //   const data = products.filter((data) => data?.category?._id === val);

  //   setProductList(data);
  // };

  // Change category and filter products
  const changeCategory = (val) => {
    setCategory(val);
    const filtered = products.filter((p) => p?.category?._id === val);
    setProductList(filtered);
  };

  const handleStartDate = (val) => {
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);

    const selected = new Date(val);
    selected.setHours(0, 0, 0, 0);

    if (selected < todayDate) {
      toast.error("Past dates are not allowed.");
      return;
    }

    setStartDate(val);
    handleNUmberOfDays(days, val);
  };

  const handleNUmberOfDays = (val, date_) => {
    setDays(val);

    const startDate_ = new Date(date_);
    startDate_.setDate(startDate_.getDate() + parseInt(val, 10) - 1);

    const year = startDate_.getFullYear();
    const month = startDate_.getMonth() + 1; // Months are 0-indexed, so add 1
    const day = startDate_.getDate();

    let date = `${year}-${month < 10 ? "0" : ""}${month}-${
      day < 10 ? "0" : ""
    }${day}`;

    setEndDate(date);
  };

  const addToOrder = async () => {
    setLoader(true);

    if (startDate === "") {
      toast.error(`Please select date`, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);

    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    if (start < todayDate) {
      toast.error("Past dates are not allowed.");
      setLoader(false);
      return;
    }

    if (Number(days) < 1) {
      toast.error("Days must be at least 1.");
      setLoader(false);
      return;
    }

    const end = new Date(start);
    end.setDate(end.getDate() + Number(days) - 1);

    if (end < start) {
      toast.error("Invalid rental period.");
      setLoader(false);
      return;
    }

    let prod = products?.filter((data) => data._id === newProduct);

    // find how mach days
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);

    const timeDiff = Math.abs(date2 - date1);

    const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + 1;

    let totalDays = daysDiff === 0 ? daysDiff + 1 : daysDiff;
    let price = prod[0]?.offerPrice * totalDays * qnty;

    let offerPrice = prod[0]?.offerPrice;

    const obj_ = {
      customer,
      product: newProduct,
      startDate,
      endDate,
      qnty,
      days: totalDays, // added days
    };

    const resp_ = await Axios.post(`/api/order/check`, obj_);

    // if (resp_.data.code != 200) {

    if (resp_.data.balStock < qnty) {
      toast.error(`🦄 ${resp_.data.balStock} Stocks Available`, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setLoader(false);
      return;
    } else {
      let obj = {
        product: newProduct,
        startDate: startDate,
        endDate: endDate,
        amount: price,
        days: totalDays,
        // index_: product?.length + 1,
        index_: product?.length,
        prodPrice: offerPrice,
        qnty: qnty,
      };

      const { data } = await Axios.post(
        `/api/order/item/add/${selectedOrder}`,
        obj,
      );
      if (data.status === 200) {
        getOrder(selectedOrder);

        setAddNewItemModal(false);

        setCategory("");
        setNewProduct("");
        setStartDate(gettodayDate());
        setEndDate(gettodayDate());
        setDays(1);
        setQnty(1);

        toast.success("Item added successfully!");
      }
    }
    setLoader(false);

    // }

    // else {
    //   toast.error(` Stocks Not Available`, {
    //     position: 'top-center',
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: 'light',
    //   });
    //   return;
    // }
  };

  console.log(product, "product");

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const compleatRentOut = async () => {
    setLoader(true);

    try {
      const confirm = window.confirm("Are you sure");

      if (!confirm) {
        setLoader(false);
        return;
      }

      const { data } = await Axios.post(`/api/order/rent-out-complete/`, {
        orderId: selectedOrder,
        amount: recAmount,
        paymentMethod,
      });

      if (data?.status === 200) {
        const TodayProduct = data?.order?.orderItems?.filter((prod) => {
          if (!prod.isDelivered || !prod.deliveredAt) return false;

          let deliveredDate = "";

          // Old format: YYYY-MM-DD
          if (
            typeof prod.deliveredAt === "string" &&
            /^\d{4}-\d{2}-\d{2}$/.test(prod.deliveredAt)
          ) {
            deliveredDate = prod.deliveredAt;
          }
          // New format: Full timestamp
          else {
            const d = new Date(prod.deliveredAt);

            if (!isNaN(d)) {
              deliveredDate =
                d.getFullYear() +
                "-" +
                String(d.getMonth() + 1).padStart(2, "0") +
                "-" +
                String(d.getDate()).padStart(2, "0");
            }
          }

          return deliveredDate === getTodayDate();
        });

        if (TodayProduct.length === 0) {
          toast.error("Please select stock");
          return;
        }

        const qrDataObj = {
          invoiceId: orderDetails.orderId,
          orderDate: getTodayDate(),
          customerName: searchCustomerRes,
          customerNumber: searchCustomer,
        };

        const qrBase64 = await QRCode.toDataURL(JSON.stringify(qrDataObj));

        setQrCodeForPdf(qrBase64);
        setProductsForPrint(TodayProduct);
        setComplete(true);

        await Axios.put(`/api/order/update-qr/${selectedOrder}`, {
          qrCode: qrBase64,
        });
      } else {
        toast.error("Failed to complete rent out.");
      }
    } catch (err) {
      console.error(err);

      toast.error(
        err?.response?.data?.message || err?.message || "Unknown error",
      );
    } finally {
      setLoader(false);
    }
  };

  const getStockFormProduct = (id) => {
    try {
      let data = products?.find((data) => data._id === id);

      checkStockIsRentOut(data?.stock).then((res) => {
        return res;
      });

      return data?.stock;
    } catch (error) {
      console.log(error);
    }

    return "as";
    // return data?.data?.stock;
  };

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const isItemCodeAlreadyUsed = (itemCode) => {
    return product.some(
      (item) => item.stock === itemCode && item.isDelivered === true,
    );
  };
  const updateRentOut = async (data, stock, skipConfirm = false) => {
    try {
      const alreadyUsed = product.some(
        (item) => item.stock === stock && item._id !== data._id,
      );

      if (alreadyUsed) {
        toast.error(
          `Item code ${stock} is already assigned to another item in this order!`,
          {
            position: "top-center",
            autoClose: 5000,
          },
        );
        return;
      }

      const productSelected = products?.find((dt) => dt._id === data.product);

      if (!productSelected) {
        toast.error("This product was deleted and cannot be rented out.", {
          position: "top-center",
          autoClose: 5000,
        });
        return;
      }

      const stockSelected = productSelected?.stock?.find(
        (st) => st.itemCode === stock,
      );

      if (!stockSelected) {
        toast.error(
          "Selected stock item not found. It may be unavailable or deleted.",
          {
            position: "top-center",
            autoClose: 5000,
          },
        );
        return;
      }

      if (!skipConfirm) {
        const confirm = window.confirm(
          "Are you sure you want to rent out this item?",
        );
        if (!confirm) return;
      }

      const obj = {
        orderId: selectedOrder,
        product: data.product,
        stock,
        date: getTodayDate(),
        itemId: data._id,
        index_: data.index_,
        serialNumber: stockSelected.serialNumber || null,
      };

      const res = await Axios.post(`/api/order/rentout`, obj);

      if (res?.data?.status === 200) {
        toast.success(`Item ${stock} rented out successfully!`, {
          position: "top-center",
          autoClose: 3000,
        });

        await getOrder(selectedOrder);
      } else {
        toast.error("Failed to rent out item. Please try again.");
      }
    } catch (error) {
      console.error("Rent out error:", error);
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong while renting out the item",
      );
    }
  };

  const handleChangeOrder = async (val) => {
    await Axios.post(`/api/order/rent-out-init`, {
      orderId: val,
    }).then((res) => {
      if (res.data.status === 200) {
        setOrderSelected(val);
        setScanStage("STOCK");
      }
    });
  };

  const removeItem = async (index_, price, days) => {
    let data = {
      selectedOrder: selectedOrder,
      index_: index_,
      amount: parseInt(price) * parseInt(days),
      customer,
    };

    if (
      window.confirm(
        "Are you sure do you want remove this item,this will permanently delete item from order",
      )
    ) {
      await Axios.post(`/api/order/delete-item`, data).then((res) => {
        getOrder(selectedOrder);
      });
    }
  };

  useEffect(() => {
    const keepFocus = () => {
      if (!qrInputRef.current) return;

      const active = document.activeElement;
      const isTyping =
        active && ["INPUT", "SELECT", "TEXTAREA"].includes(active.tagName);

      if (!isTyping && !showQRModal && !showStockScanModal) {
        qrInputRef.current.focus({ preventScroll: true });
      }
    };

    const id = setInterval(keepFocus, 400);
    return () => clearInterval(id);
  }, [showQRModal, showStockScanModal]);

  const handleQRKeyboardScan = async (text) => {
    let parsed = null;

    try {
      parsed = JSON.parse(text);
    } catch (err) {
      toast.error("QR Code Error — try manual adding");
      return;
    }

    if (!parsed.orderId || !parsed.customerNumber) {
      toast.error("QR Code Error — try manual adding");
      return;
    }

    const loaderTimeout = setTimeout(() => {
      setIsLoadingOrderScan(true);
    }, 200);

    setScannedQRData(parsed);
    setShowQRModal(true);
    clearTimeout(loaderTimeout);
  };

  const handleAddScannedOrder = async () => {
    if (!scannedQRData) return;

    setShowQRModal(false);
    setIsLoadingOrderScan(true);

    try {
      setQrResult(scannedQRData);
      setSearchCustomer(scannedQRData.customerNumber);

      const fakeEvent = {
        keyCode: 13,
        target: { value: scannedQRData.customerNumber },
      };

      await customerSearchFunction(fakeEvent);

      setQrPending(true);
      setScanStage("STOCK");

      setScannedQRData(null);
    } catch (error) {
      console.error("Error processing order:", error);
      toast.error("Failed to load order");
      setIsLoadingOrderScan(false);
    }
  };

  useEffect(() => {
    if (qrPending && orders.length > 0) {
      const foundOrder = orders.find(
        (o) => Number(o.orderId) === Number(qrResult.orderId),
      );

      if (foundOrder) {
        handleChangeOrder(foundOrder._id);
      } else {
        toast.error("Order not found for this customer");
      }

      setQrPending(false);

      setIsLoadingOrderScan(false);
    }
  }, [orders]);

  const handleCancelScan = () => {
    setShowQRModal(false);
    setScannedQRData(null);
    setIsLoadingOrderScan(false);
    toast.info("Scan cancelled");
  };

  useEffect(() => {
    if (qrPending && orders.length > 0) {
      const foundOrder = orders.find(
        (o) => Number(o.orderId) === Number(qrResult.orderId),
      );

      if (foundOrder) {
        handleChangeOrder(foundOrder._id);
      } else {
        toast.error("Order not found for this customer");
      }

      setQrPending(false);
      setIsLoadingOrderScan(false);
    }
  }, [orders]);

  const handleItemCodeScan = async (code) => {
    if (!selectedOrder) {
      toast.error("Scan order QR first!");
      return;
    }

    let raw = code.trim();
    let extractedItemCode = raw;

    try {
      const parsed = JSON.parse(raw);
      if (parsed.itemCode) {
        extractedItemCode = parsed.itemCode;
        console.log("Extracted itemCode from JSON:", extractedItemCode);
      }
    } catch (err) {}

    const finalCode = extractedItemCode.replace(/\s+/g, "").toUpperCase();

    const alreadyUsedInOrder = product.some((item) => {
      if (!item.stock) return false;

      const stockValue =
        typeof item.stock === "string" ? item.stock : String(item.stock);

      return stockValue.replace(/\s+/g, "").toUpperCase() === finalCode;
    });

    if (alreadyUsedInOrder) {
      toast.error(`Item code ${finalCode} is already assigned in this order!`, {
        position: "top-center",
        autoClose: 5000,
      });
      return;
    }

    const productData = product.find((p) => {
      const hasStock = p.stocks?.some((s) => {
        if (!s.itemCode) return false;
        return s.itemCode.replace(/\s+/g, "").toUpperCase() === finalCode;
      });

      const hasNoStockAssigned =
        !p.stock ||
        p.stock === "" ||
        (Array.isArray(p.stock) && p.stock.length === 0);

      return hasStock && hasNoStockAssigned;
    });

    if (productData) {
      const stockInfo = productData.stocks.find(
        (s) =>
          s.itemCode &&
          s.itemCode.replace(/\s+/g, "").toUpperCase() === finalCode,
      );

      setScannedStockData({ productData, stockInfo });
      setShowStockScanModal(true);
    } else {
      // Item not in order - fetch from database and show add modal
      try {
        const { data } = await Axios.get(
          `/api/products/stockdata?itemCode=${extractedItemCode}`,
        );

        if (data && data.stock) {
          // Item exists in database but not in this order
          setScannedNewItem({
            itemCode: data.stock.itemCode,
            serialNumber: data.stock.serialNumber,
            productId: data.productId,
            productName: data.productName,
          });
          setShowAddItemModal(true);
        } else {
          toast.error("Item code not found in database");
        }
      } catch (error) {
        console.error("Error fetching item:", error);
        toast.error("Item not found in database");
      }
    }
  };

  const handleAddItemDays = (val, date_) => {
    setAddItemDays(val);

    const startDate_ = new Date(date_);
    startDate_.setDate(startDate_.getDate() + parseInt(val, 10) - 1);

    const year = startDate_.getFullYear();
    const month = startDate_.getMonth() + 1;
    const day = startDate_.getDate();

    let date = `${year}-${month < 10 ? "0" : ""}${month}-${
      day < 10 ? "0" : ""
    }${day}`;

    setAddItemEndDate(date);
  };

  const handleAddScannedNewItem = async () => {
    if (!scannedNewItem) return;

    setCheckingAvailability(true);

    try {
      // Check availability
      const checkData = {
        customer,
        product: scannedNewItem.productId,
        startDate: addItemStartDate,
        endDate: addItemEndDate,
        qnty: addItemQnty,
        days: addItemDays,
      };

      const resp = await Axios.post(`/api/order/check`, checkData);

      if (resp.data.balStock < addItemQnty) {
        toast.error(`Only ${resp.data.balStock} items available`, {
          position: "top-center",
          autoClose: 5000,
        });
        setCheckingAvailability(false);
        return;
      }

      const prod = products.find((p) => p._id === scannedNewItem.productId);
      const price = prod?.offerPrice * addItemDays * addItemQnty;

      const { data: currentOrder } = await Axios.get(
        `/api/order/${selectedOrder}`,
      );
      const nextIndex = currentOrder.orderItems?.length || 0;

      const addObj = {
        product: scannedNewItem.productId,
        startDate: addItemStartDate,
        endDate: addItemEndDate,
        amount: price,
        days: addItemDays,
        index_: nextIndex,
        prodPrice: prod?.offerPrice,
        qnty: addItemQnty,
      };

      const { data: addData } = await Axios.post(
        `/api/order/item/add/${selectedOrder}`,
        addObj,
      );

      if (addData.status === 200) {
        // Close the modal
        setShowAddItemModal(false);
        toast.info("Item added! Assigning stock...");

        // Step 2: Get fresh order data
        const { data: orderData } = await Axios.get(
          `/api/order/${selectedOrder}`,
        );

        // Find the newly added item (it will be the last one with this product ID that's not delivered)
        const newItem = orderData.orderItems
          .filter(
            (item) =>
              item.product === scannedNewItem.productId && !item.isDelivered,
          )
          .pop(); // Get the last one (newest)

        if (newItem) {
          // Step 3: Assign the stock directly using the API
          const productSelected = products?.find(
            (dt) => dt._id === scannedNewItem.productId,
          );
          const stockSelected = productSelected?.stock?.find(
            (st) => st.itemCode === scannedNewItem.itemCode,
          );

          if (stockSelected) {
            const assignObj = {
              orderId: selectedOrder,
              product: scannedNewItem.productId,
              stock: scannedNewItem.itemCode,
              date: getTodayDate(),
              itemId: newItem._id,
              index_: newItem.index_ || orderData.orderItems.length - 1,
              serialNumber: stockSelected.serialNumber,
            };

            await Axios.post(`/api/order/rentout`, assignObj);

            toast.success(
              `✓ Item ${scannedNewItem.itemCode} added and assigned!`,
              {
                position: "top-center",
                autoClose: 3000,
              },
            );
          } else {
            toast.warning(
              "Item added but stock not found. Please assign manually.",
            );
          }
        } else {
          toast.warning("Item added but couldn't find it to assign stock.");
        }

        // Reset states
        setScannedNewItem(null);
        setAddItemStartDate(getTodayDate());
        setAddItemEndDate(getTodayDate());
        setAddItemDays(1);
        setAddItemQnty(1);

        await getOrder(selectedOrder);
      }
    } catch (error) {
      console.error("Error adding item:", error);
      toast.error(
        error.response?.data?.message || "Failed to add item to order",
      );
    } finally {
      setCheckingAvailability(false);
    }
  };

  const handleCancelAddNewItem = () => {
    setShowAddItemModal(false);
    setScannedNewItem(null);
    setAddItemStartDate(getTodayDate());
    setAddItemEndDate(getTodayDate());
    setAddItemDays(1);
    setAddItemQnty(1);
  };

  const handleAddScannedStock = async () => {
    if (!scannedStockData) return;

    setShowStockScanModal(false);

    await updateRentOut(
      scannedStockData.productData,
      scannedStockData.stockInfo.itemCode,
      true,
    );

    toast.success(
      `Item ${scannedStockData.stockInfo.itemCode} assigned successfully!`,
    );

    setScannedStockData(null);
  };

  const handleCancelStockScan = () => {
    setShowStockScanModal(false);
    setScannedStockData(null);
    toast.info("Stock scan cancelled");
  };
  const calculateTotalOrderAmount = () => {
    if (!product || product.length === 0) return 0;

    return product.reduce((total, item) => {
      const itemTotal =
        (item.prodPrice || 0) * (item.days || 0) * (item.qnty || 1);
      return total + itemTotal;
    }, 0);
  };
  return (
    <div>
      {" "}
      {/* <form onSubmit={onSubmit}> */}
      <div class="card p-4">
        <div className="rentout-1st-row">
          <div className="rentout-card-1">
            {!customerDetails || !selectedOrder ? (
              <>
                <div className="rentout-card-row">
                  <button
                    className="add-order-btn"
                    onClick={() => setAddOrderModal(true)}
                  >
                    <i className="mdi mdi-plus"></i>
                    <span className="btn-text">Add Order</span>
                  </button>
                </div>
                <div className="empty-card-message">
                  <i className="mdi mdi-qrcode-scan empty-icon"></i>
                  <p className="empty-title">No customer selected</p>
                  <p className="empty-subtitle">
                    Scan a QR code or enter a customer number to continue.
                  </p>
                </div>
              </>
            ) : (
              <div className="customer-card">
                <div className="customer-header">
                  <div>
                    <h2 className="customer-name">
                      {customerDetails.user.name.split(" ")[0]}
                      <br />
                      {customerDetails.user.name.split(" ")[1] || ""}
                    </h2>
                  </div>

                  <div className="customer-avatar">
                    {customerDetails.user.name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")
                      .toUpperCase()}
                  </div>
                </div>

                <div className="info-row">
                  <i className="mdi mdi-cart-outline info-icon"></i>
                  <div>
                    <p className="info-label">Order ID</p>
                    <p className="info-value">ADC_{orderDetails.orderId}</p>
                  </div>
                </div>

                <div className="info-row">
                  <i className="mdi mdi-phone-outline info-icon"></i>
                  <div>
                    <p className="info-label">PHONE</p>
                    <p className="info-value">{customerDetails.user.phone}</p>
                  </div>
                </div>

                <div className="stats-row">
                  <div className="stat-box stat-left">
                    <p className="stat-label">TOTAL ORDERS</p>
                    <h3 className="stat-number">{orders.length}</h3>
                    <p className="stat-unit">order</p>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="rentout-card-2">
            {!selectedOrder ? (
              <div className="rentout-empty">
                <i className="mdi mdi-alert-circle-outline empty-icon"></i>
                <p className="empty-title">No order selected</p>
                <p className="empty-subtitle">
                  Please scan a QR or select an order to continue.
                </p>
              </div>
            ) : (
              <div className="rentout-order-info">
                <div className="info-line">
                  <span>Order Amount</span>
                  <span>: {calculateTotalOrderAmount()}</span>
                </div>

                <div className="info-line">
                  <span>Discount</span>
                  <span>: {orderDetails?.discount}</span>
                </div>

                <div className="info-line">
                  <span>Total Received</span>
                  <span>: {orderDetails?.totalReceive}</span>
                </div>

                <hr />

                <div className="info-line">
                  <span>Receive</span>
                  <input
                    type="number"
                    className="form-control receive-input"
                    min={0}
                    onChange={(e) => setRecAmount(e.target.value)}
                    required
                    value={recAmount}
                  />
                </div>

                <div className="info-line">
                  <span>Payment Method</span>
                  <select
                    className="form-control"
                    value={paymentMethod}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                  >
                    <option value="cash">Cash</option>
                    <option value="upi">UPI</option>
                  </select>
                </div>

                <div className="info-line">
                  <span>Total Amount Rec</span>
                  <span>
                    :{" "}
                    {parseInt(orderDetails?.totalReceive || 0) +
                      parseInt(recAmount || 0)}
                  </span>
                </div>

                <div className="info-line">
                  <span>Balance</span>
                  <span>
                    {" "}
                    :{" "}
                    {calculateTotalOrderAmount() -
                      (parseInt(orderDetails?.discount || 0) +
                        parseInt(orderDetails?.totalReceive || 0) +
                        parseInt(recAmount || 0))}
                  </span>
                </div>

                {loader ? (
                  <div className="d-flex justify-content-center mt-3">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden"></span>
                    </div>
                  </div>
                ) : (
                  <div className="btn-row">
                    {compleat === true ? (
                      <button
                        className="ok-btn cancel"
                        onClick={() => window.location.reload()}
                      >
                        Cancel
                      </button>
                    ) : (
                      <button className="ok-btn" onClick={compleatRentOut}>
                        Ok
                      </button>
                    )}

                    {compleat === true && (
                      <PDFDownloadLink
                        document={
                          <RentOutPrint
                            products={products}
                            customerName={searchCustomerRes}
                            customerNumber={searchCustomer}
                            address={customerDetails?.user?.address1}
                            invoiceId={orderDetails.orderId}
                            orderDate={getTodayDate()}
                            items={productsForPrint}
                            advance={
                              Number(orderDetails?.totalReceive || 0) +
                              Number(recAmount || 0)
                            }
                            amount={calculateTotalOrderAmount()}
                            discount={orderDetails?.discount}
                            qrCode={qrCodeForPdf}
                          />
                        }
                        fileName={`${searchCustomerRes}.pdf`}
                      >
                        {({ loading }) => (
                          <button className="ok-btn print-btn">
                            {loading ? "Loading..." : "Print"}
                          </button>
                        )}
                      </PDFDownloadLink>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* table */}

        <div className="w-100 card p-3 mb-4 rentout-table-wrapper">
          {" "}
          <div class="table-responsive">
            <div className="rentout-table-row">
              <p style={{ fontWeight: "bold" }}>Ordered Items</p>
              {!!selectedOrder && (
                <button
                  className="add-order-btn"
                  onClick={() => setAddNewItemModal(true)}
                >
                  <i className="mdi mdi-plus"></i>
                  <span className="btn-text">Add New Item</span>
                </button>
              )}
            </div>
            <table class="display expandable-table" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Number</th>
                  <th>Product</th>
                  <th>Stock</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Days</th>
                  <th>Price</th>
                  <th>Rent out</th>

                  <th></th>
                </tr>
              </thead>
              <tbody>
                {product && product.length > 0 ? (
                  product?.map((data, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{productName(data.product)}</td>
                      <td>
                        {data.isDelivered === true ? (
                          data.stock || "-"
                        ) : data.stocks && data.stocks.length > 0 ? (
                          <select
                            className="form-control"
                            value={data.stock || ""}
                            onChange={(e) =>
                              updateRentOut(data, e.target.value)
                            }
                          >
                            <option value="">Select Stock</option>
                            {data.stocks
                              .filter(
                                (stockItem) =>
                                  stockItem?.itemCode &&
                                  stockItem.itemCode.trim() !== "",
                              )
                              .map((stockItem) => (
                                <option
                                  key={stockItem.itemCode}
                                  value={stockItem.itemCode}
                                >
                                  {stockItem.itemCode}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <span style={{ color: "#dc3545", fontWeight: 600 }}>
                            No stock available
                          </span>
                        )}
                      </td>

                      <td>{data.startDate}</td>
                      <td>{data.endDate}</td>
                      <td>{data.days}</td>
                      <td>{data.prodPrice}</td>
                      <td>
                        {data.isDelivered === true ? (
                          "DONE"
                        ) : (
                          <div style={{ color: "red" }}>NOT</div>
                        )}
                      </td>
                      <td>
                        <i
                          class="mdi mdi-close-octagon-outline"
                          style={{ color: "red" }}
                          onClick={(e) =>
                            removeItem(data.index_, data.prodPrice, data.days)
                          }
                        ></i>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center text-black">
                      No Orders Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* old ui */}
      </div>
      {/* </form> */}
      <ToastContainer />
      {/* Hidden QR input */}
      <input
        id="qr-hidden-input"
        type="text"
        ref={qrInputRef}
        autoFocus
        style={{
          position: "fixed",
          top: 0,
          left: -9999,
          width: 1,
          height: 1,
          opacity: 0,
          pointerEvents: "none",
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            const text = e.target.value.trim();
            e.target.value = "";
            if (showQRModal || showStockScanModal) return;

            if (scanStage === "ORDER") {
              handleQRKeyboardScan(text);
            } else if (scanStage === "STOCK") {
              handleItemCodeScan(text);
            }
          }
        }}
      />
      {/* Scan Confirmation Modal */}
      {showQRModal && scannedQRData && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              padding: 30,
              width: 450,
              maxWidth: "90%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
                handleAddScannedOrder();
              } else if (e.key === "Escape") {
                handleCancelScan();
              }
            }}
            tabIndex={-1}
            ref={(el) => {
              if (el) {
                setTimeout(() => el.focus(), 50);
              }
            }}
          >
            <h4
              style={{ marginBottom: 20, color: "#333", textAlign: "center" }}
            >
              ✓ Order Found!
            </h4>

            <div style={{ marginBottom: 25, fontSize: 15 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 12,
                  paddingBottom: 12,
                  borderBottom: "1px solid #eee",
                }}
              >
                <strong style={{ color: "#666" }}>Order ID:</strong>
                <span style={{ color: "#000", fontWeight: 500 }}>
                  ADC_{scannedQRData.orderId}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 12,
                  paddingBottom: 12,
                  borderBottom: "1px solid #eee",
                }}
              >
                <strong style={{ color: "#666" }}>Name:</strong>
                <span style={{ color: "#000", fontWeight: 500 }}>
                  {scannedQRData.customerName || "N/A"}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 12,
                  paddingBottom: 12,
                  borderBottom: "1px solid #eee",
                }}
              >
                <strong style={{ color: "#666" }}>Phone:</strong>
                <span style={{ color: "#000", fontWeight: 500 }}>
                  {scannedQRData.customerNumber}
                </span>
              </div>
            </div>

            <div
              style={{
                fontSize: 14,
                color: "#666",
                marginBottom: 20,
                textAlign: "center",
              }}
            >
              Add this order?
            </div>

            <div
              style={{
                display: "flex",
                gap: 10,
                justifyContent: "flex-end",
                marginTop: 25,
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={handleCancelScan}
                style={{ minWidth: 100 }}
                type="button"
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleAddScannedOrder}
                style={{ minWidth: 100 }}
                type="button"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Stock Scan Confirmation Modal */}
      {showStockScanModal && scannedStockData && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              padding: 30,
              width: 450,
              maxWidth: "90%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
                handleAddScannedStock();
              } else if (e.key === "Escape") {
                handleCancelStockScan();
              }
            }}
            tabIndex={-1}
            ref={(el) => {
              if (el) {
                setTimeout(() => el.focus(), 50);
              }
            }}
          >
            <h4
              style={{ marginBottom: 20, color: "#333", textAlign: "center" }}
            >
              ✓ Item Found!
            </h4>

            <div style={{ marginBottom: 25, fontSize: 15 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 12,
                  paddingBottom: 12,
                  borderBottom: "1px solid #eee",
                }}
              >
                <strong style={{ color: "#666" }}>Product:</strong>
                <span style={{ color: "#000", fontWeight: 500 }}>
                  {productName(scannedStockData.productData.product)}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 12,
                  paddingBottom: 12,
                  borderBottom: "1px solid #eee",
                }}
              >
                <strong style={{ color: "#666" }}>Item Code:</strong>
                <span style={{ color: "#000", fontWeight: 500 }}>
                  {scannedStockData.stockInfo.itemCode}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 12,
                  paddingBottom: 12,
                  borderBottom: "1px solid #eee",
                }}
              >
                <strong style={{ color: "#666" }}>Serial Number:</strong>
                <span style={{ color: "#000", fontWeight: 500 }}>
                  {scannedStockData.stockInfo.serialNumber || "N/A"}
                </span>
              </div>
            </div>

            <div
              style={{
                fontSize: 14,
                color: "#666",
                marginBottom: 20,
                textAlign: "center",
              }}
            >
              Assign this item?
            </div>

            <div
              style={{
                display: "flex",
                gap: 10,
                justifyContent: "flex-end",
                marginTop: 25,
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={handleCancelStockScan}
                style={{ minWidth: 100 }}
                type="button"
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleAddScannedStock}
                style={{ minWidth: 100 }}
                type="button"
              >
                Assign
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Add Order Modal */}
      {AddOrderModal === true && (
        <div className="add-order-modal-overlay">
          <div className="add-order-modal-box" tabIndex={-1}>
            <h3 className="add-order-modal-title">Add Order</h3>

            <div className="add-order-modal-field">
              <label className="add-order-modal-label">Search Customer</label>
              <input
                type="text"
                className="add-order-modal-input"
                placeholder="Enter customer number"
                value={searchCustomer}
                onChange={(e) => setSearchCustomer(e.target.value)}
                onKeyDown={(e) => customerSearchFunction(e)}
              />
            </div>

            <div className="add-order-modal-result">
              {searchCustomerLoading ? (
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden"></span>
                </div>
              ) : (
                <>
                  <p className="add-order-modal-customer-name">
                    {searchCustomerRes}
                  </p>

                  {customerError && (
                    <p className="add-order-modal-error">{customerError}</p>
                  )}
                </>
              )}
            </div>

            {orders?.length > 0 && (
              <div className="add-order-modal-field">
                <label className="add-order-modal-label">Select Order</label>

                <select
                  className="add-order-modal-select"
                  required
                  onChange={(e) => {
                    handleChangeOrder(e.target.value);
                    setAddOrderModal(false);
                  }}
                  value={selectedOrder}
                >
                  <option value="">Select Order</option>
                  {orders?.map((data) => (
                    <option key={data._id} value={data._id}>
                      ADC_{data.orderId}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="add-order-modal-actions">
              <button
                className="add-order-modal-btn cancel"
                onClick={() => {
                  setTempSelectedOrder("");
                  setSearchCustomer("");
                  setCustomerError("");
                  setResCustomer("");
                  setOrders([]);
                  setAddOrderModal(false);
                }}
              >
                Cancel
              </button>
              {/* {orders?.length > 0 && (
                <button
                  className="add-order-modal-btn add"
                  disabled={!tempSelectedOrder}
                  onClick={() => {
                    handleChangeOrder(tempSelectedOrder);
                    setAddOrderModal(false);
                  }}
                >
                  Continue
                </button>
              )} */}
            </div>
          </div>
        </div>
      )}
      {/* Add New Item Modal */}
      {AddNewItemModal === true && (
        <div className="add-order-modal-overlay">
          <div className="add-order-modal-box" tabIndex={-1}>
            <h3 className="add-order-modal-title">Add New Item</h3>

            <div className="add-order-modal-field">
              <label className="add-order-modal-label">Select Category</label>
              <select
                className="add-order-modal-select"
                required
                value={category}
                onChange={(e) => changeCategory(e.target.value)}
              >
                <option value="">Select Category</option>

                {categories
                  ?.slice() // ✅ avoid mutating state
                  .sort((a, b) => a.categoryName.localeCompare(b.categoryName))
                  .map((data) => (
                    <option key={data._id} value={data._id}>
                      {data.categoryName}
                    </option>
                  ))}
              </select>
            </div>

            <div className="add-order-modal-field">
              <label className="add-order-modal-label">Select Product</label>
              <select
                className="add-order-modal-select"
                required
                value={newProduct}
                onChange={(e) => setNewProduct(e.target.value)}
              >
                <option value="">Select Product</option>
                {productList_?.map((data) => (
                  <option value={data._id}>{data.name}</option>
                ))}
              </select>
            </div>

            <div className="add-order-modal-field">
              <label className="add-order-modal-label">Start Date</label>
              <input
                type="date"
                className="add-order-modal-input"
                required
                min={today}
                value={startDate}
                onChange={(e) => handleStartDate(e.target.value)}
                onKeyDown={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
                onDrop={(e) => e.preventDefault()}
                autoComplete="off"
              />
            </div>

            <div className="add-order-modal-row">
              <div className="add-order-modal-col">
                <label className="add-order-modal-label">Days</label>
                <input
                  type="number"
                  className="add-order-modal-input"
                  min={1}
                  value={days}
                  onChange={(e) => {
                    const value = Math.max(1, Number(e.target.value) || 1);
                    handleNUmberOfDays(value, startDate);
                  }}
                  disabled={!startDate}
                />
              </div>

              <div className="add-order-modal-col">
                <label className="add-order-modal-label">End Date</label>
                <div className="add-order-modal-enddate">{endDate}</div>
              </div>
            </div>

            <div className="add-order-modal-field">
              <label className="add-order-modal-label">Quantity</label>
              <input
                type="number"
                className="add-order-modal-input"
                required
                min={1}
                value={qnty}
                onChange={(e) =>
                  setQnty(Math.max(1, Number(e.target.value) || 1))
                }
                disabled={!startDate}
              />
            </div>

            {availability === 200 && (
              <div className="add-order-success">
                Items available for this date!
              </div>
            )}

            {availability === 400 && (
              <div className="add-order-error">
                Not Available! Items not available for this date.
              </div>
            )}

            <div className="add-order-modal-actions">
              <button
                className="add-order-modal-btn cancel"
                onClick={() => setAddNewItemModal(false)}
              >
                Cancel
              </button>

              {loader ? (
                <div className="spinner-border text-primary"></div>
              ) : (
                <button
                  className="add-order-modal-btn add"
                  disabled={!newProduct || !category}
                  onClick={addToOrder}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {/* Add Scanned Item Not in Order Modal */}
      {showAddItemModal && scannedNewItem && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              padding: 30,
              width: 500,
              maxWidth: "90%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
            onKeyDown={(e) => {
              if (e.key === "Escape") {
                handleCancelAddNewItem();
              }
            }}
            tabIndex={-1}
            ref={(el) => {
              if (el) {
                setTimeout(() => el.focus(), 50);
              }
            }}
          >
            <h4
              style={{ marginBottom: 20, color: "#333", textAlign: "center" }}
            >
              ⚠️ Item Not in Current Order
            </h4>

            <div style={{ marginBottom: 25, fontSize: 15 }}>
              <div
                style={{
                  background: "#f8f9fa",
                  padding: 15,
                  borderRadius: 8,
                  marginBottom: 20,
                }}
              >
                <div style={{ marginBottom: 10 }}>
                  <strong style={{ color: "#666" }}>Product:</strong>
                  <span
                    style={{ color: "#000", fontWeight: 500, marginLeft: 10 }}
                  >
                    {scannedNewItem.productName}
                  </span>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <strong style={{ color: "#666" }}>Item Code:</strong>
                  <span
                    style={{ color: "#000", fontWeight: 500, marginLeft: 10 }}
                  >
                    {scannedNewItem.itemCode}
                  </span>
                </div>
                <div>
                  <strong style={{ color: "#666" }}>Serial Number:</strong>
                  <span
                    style={{ color: "#000", fontWeight: 500, marginLeft: 10 }}
                  >
                    {scannedNewItem.serialNumber || "N/A"}
                  </span>
                </div>
              </div>

              <p
                style={{
                  color: "#dc3545",
                  marginBottom: 20,
                  textAlign: "center",
                }}
              >
                This item is not booked in the current order. Would you like to
                add it now?
              </p>

              <div style={{ marginBottom: 15 }}>
                <label
                  style={{ display: "block", marginBottom: 5, fontWeight: 600 }}
                >
                  Start Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={addItemStartDate}
                  min={today}
                  onKeyDown={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  onDrop={(e) => e.preventDefault()}
                  onChange={(e) => {
                    const value = e.target.value;

                    const todayDate = new Date();
                    todayDate.setHours(0, 0, 0, 0);

                    const selected = new Date(value);
                    selected.setHours(0, 0, 0, 0);

                    if (selected < todayDate) {
                      toast.error("Past dates are not allowed.");
                      return;
                    }

                    setAddItemStartDate(value);
                    handleAddItemDays(addItemDays, value);
                  }}
                />
              </div>

              <div style={{ display: "flex", gap: 15, marginBottom: 15 }}>
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: 5,
                      fontWeight: 600,
                    }}
                  >
                    Days
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={addItemDays}
                    min={1}
                    onChange={(e) =>
                      handleAddItemDays(e.target.value, addItemStartDate)
                    }
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: 5,
                      fontWeight: 600,
                    }}
                  >
                    End Date
                  </label>
                  <div
                    style={{
                      padding: "8px 12px",
                      background: "#e9ecef",
                      borderRadius: 4,
                      marginTop: 5,
                    }}
                  >
                    {addItemEndDate}
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: 15 }}>
                <label
                  style={{ display: "block", marginBottom: 5, fontWeight: 600 }}
                >
                  Quantity
                </label>
                <input
                  type="number"
                  className="form-control"
                  value={addItemQnty}
                  min={1}
                  onChange={(e) => setAddItemQnty(e.target.value)}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: 10,
                justifyContent: "flex-end",
                marginTop: 25,
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={handleCancelAddNewItem}
                style={{ minWidth: 100 }}
                type="button"
                disabled={checkingAvailability}
              >
                Cancel
              </button>
              <button
                className="btn btn-success"
                onClick={handleAddScannedNewItem}
                style={{ minWidth: 100 }}
                type="button"
                disabled={checkingAvailability}
              >
                {checkingAvailability ? (
                  <>
                    <span className="spinner-border spinner-border-sm mr-2"></span>
                    Checking...
                  </>
                ) : (
                  "Add to Order"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      <Loader
        isLoading={isLoadingOrderScan}
        setIsLoading={setIsLoadingOrderScan}
      />
    </div>
  );
}
